import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Timbroam UI boundary caught an error", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <section className="error-badge" role="alert">
          Instrument UI failed to render: {this.state.error.message}
        </section>
      );
    }

    return this.props.children;
  }
}
